import { DataSource, CdkTableModule } from '@angular/cdk/table';
import { DataSource as DataSource$1 } from '@angular/cdk/collections';
import * as i1 from '@angular/common/http';
import { HttpHeaders, HttpClient, HttpEventType, HttpResponse, HttpClientModule } from '@angular/common/http';
import * as i0 from '@angular/core';
import { Injectable, Input, Component, ViewChild, EventEmitter, Directive, HostBinding, Output, HostListener, NgModule } from '@angular/core';
import { of, Subject, BehaviorSubject } from 'rxjs';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatInputModule } from '@angular/material/input';
import { MatNativeDateModule, MatRippleModule } from '@angular/material/core';
import { MatFormFieldModule, MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormsModule, ReactiveFormsModule, FormControl } from '@angular/forms';
import { MatDialogRef, MatDialogModule, MatDialog } from '@angular/material/dialog';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';
import { A11yModule } from '@angular/cdk/a11y';
import { ClipboardModule } from '@angular/cdk/clipboard';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { PortalModule } from '@angular/cdk/portal';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { CdkStepperModule } from '@angular/cdk/stepper';
import { CdkTreeModule } from '@angular/cdk/tree';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatBadgeModule } from '@angular/material/badge';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatStepperModule } from '@angular/material/stepper';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule, MatPaginator } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSliderModule } from '@angular/material/slider';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSortModule, MatSort } from '@angular/material/sort';
import { MatTableModule, MatTableDataSource } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatTreeModule } from '@angular/material/tree';
import { OverlayModule } from '@angular/cdk/overlay';

class Action {
}
var ActionType;
(function (ActionType) {
    ActionType["Flyout"] = "flyout";
    ActionType["Toggle"] = "toggle";
    ActionType["Button"] = "button";
})(ActionType || (ActionType = {}));

class Department {
}

class FileroomFile {
}

class SearchCriteria {
}

class Tag {
}

class DepartmentDataSource extends DataSource {
    constructor(fileroomService) {
        super();
        this.fileroomService = fileroomService;
        this.departments = new Array();
    }
    connect() {
        // this.fileroomService.getDepartments().subscribe((x) => (this.departments = x));
        return this.fileroomService.getDepartments();
    }
    disconnect() { }
}

class TagDataSource extends DataSource {
    constructor(fileroomService) {
        super();
        this.fileroomService = fileroomService;
        this.tags = new Array();
    }
    connect() {
        // this.fileroomService.getTags().subscribe((x) => (this.tags = x));
        return this.fileroomService.getTags();
    }
    disconnect() { }
}

class FileroomService {
    constructor(http) {
        this.http = http;
        this.httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
        };
        this.rootUrl = 'http://localhost:11429';
        this.apiKey = '';
        this.siteId = '';
        this.customerId = '';
        this.defaultHeaders = {
            'Content-Type': 'application/json',
            'x-api-key': this.apiKey,
            'x-site-id': this.siteId,
            'x-customer-id': this.customerId,
        };
    }
    configureHeaders() {
        this.defaultHeaders = {
            'Content-Type': 'application/json',
            'x-api-key': this.apiKey,
            'x-site-id': this.siteId,
            'x-customer-id': this.customerId,
        };
    }
    getFiles() {
        this.configureHeaders();
        const fileUrl = this.rootUrl + '/api/files';
        return this.http.get(fileUrl, {
            headers: this.defaultHeaders
        });
    }
    getTags() {
        this.configureHeaders();
        const tagUrl = this.rootUrl + '/api/tags';
        return this.http.get(tagUrl, {
            headers: this.defaultHeaders
        });
    }
    getDepartments() {
        this.configureHeaders();
        const deptUrl = this.rootUrl + '/api/departments';
        return this.http.get(deptUrl, {
            headers: this.defaultHeaders
        });
    }
    deleteFileById(id) {
        this.configureHeaders();
        const deleteUrl = this.rootUrl + '/api/files/' + id;
        return this.http.delete(deleteUrl, {
            headers: this.defaultHeaders
        });
    }
    getFileById(id) {
        this.configureHeaders();
        const downloadUrl = this.rootUrl + '/api/files/' + id;
        return this.http.get(downloadUrl, { responseType: 'blob', headers: this.defaultHeaders });
    }
    search(criteria) {
        this.configureHeaders();
        const searchUrl = this.rootUrl + '/api/search';
        return this.http.post(searchUrl, criteria, { headers: this.defaultHeaders });
    }
    handleError(operation = 'operation', result) {
        return (error) => {
            // TODO: send the error to remote logging infrastructure
            console.error(error); // log to console instead
            // TODO: better job of transforming error for user consumption
            this.log(`${operation} failed: ${error.message}`);
            // Let the app keep running by returning an empty result.
            return of(result);
        };
    }
    log(message) {
        console.error(message);
    }
}
FileroomService.ɵprov = i0.ɵɵdefineInjectable({ factory: function FileroomService_Factory() { return new FileroomService(i0.ɵɵinject(i1.HttpClient)); }, token: FileroomService, providedIn: "root" });
FileroomService.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root',
            },] }
];
FileroomService.ctorParameters = () => [
    { type: HttpClient }
];

class FileroomDataSource extends DataSource$1 {
    constructor(fileroomService) {
        super();
        this.fileroomService = fileroomService;
    }
    connect() {
        return this.fileroomService.getFiles();
    }
    disconnect() { }
}
FileroomDataSource.decorators = [
    { type: Injectable }
];
FileroomDataSource.ctorParameters = () => [
    { type: FileroomService }
];

const url = 'http://localhost:11429/api/files';
class FileroomUploadService {
    constructor(http) {
        this.http = http;
        this.fileroomApi = url;
        this.fileroomApiKey = null;
        this.siteId = null;
        this.customerId = null;
        this.authority = null;
        this.household = null;
        this.userId = null;
        this.siteSection = null;
        this.siteSectionId = null;
        this.siteSubsection = null;
        this.defaultHeaders = null;
    }
    configureHeaders() {
        this.defaultHeaders = new HttpHeaders({
            //'Content-Type': 'multipart/form-data;',
            'x-api-key': this.fileroomApiKey,
            'x-site-id': this.siteId,
            'x-customer-id': this.customerId,
        });
    }
    upload(customFile) {
        this.configureHeaders();
        const formData = new FormData();
        formData.append('files', customFile.file, customFile.file.name);
        this.prepareFormData(formData, customFile);
        const progress = new Subject();
        this.http
            .post(`${this.fileroomApi}/api/files`, formData, {
            headers: this.defaultHeaders,
            reportProgress: true,
            observe: 'events',
        })
            .subscribe((event) => {
            var _a, _b, _c;
            if (event.type === HttpEventType.UploadProgress) {
                // Calculate and emit the upload progress
                const percentDone = Math.round((100 * event.loaded) / ((_a = event.total) !== null && _a !== void 0 ? _a : 1));
                progress.next(percentDone);
            }
            else if (event instanceof HttpResponse) {
                if (event.status >= 200 && event.status <= 300) {
                    let files = event === null || event === void 0 ? void 0 : event.body;
                    (_b = customFile.id) === null || _b === void 0 ? void 0 : _b.next((_c = files[0]) === null || _c === void 0 ? void 0 : _c.value); // Update the file object with the received ID
                }
                else {
                    //error state - display error text for this file.
                    console.log(event.statusText + '\n' + event.body);
                }
                progress.complete();
            }
        }, (error) => {
            // Handle upload error
            console.error('Upload error: ', error);
            progress.error(error);
        });
        return progress.asObservable();
    }
    prepareFormData(formData, customFile) {
        let metadata = new Array();
        if (this.userId)
            metadata.push({ key: 'user', value: this.userId });
        if (this.authority)
            formData.set('authority', this.authority);
        if (this.household)
            formData.set('household', this.household);
        if (this.siteSection) {
            let idName = `${this.siteSection}Id`;
            metadata.push({ key: 'documentType', value: this.siteSection });
            metadata.push({ key: idName, value: this.siteSectionId });
        }
        if (this.siteSubsection) {
            customFile.tags.push(this.siteSubsection);
        }
        formData.set('description', customFile.file.name);
        formData.set('name', customFile.file.name);
        formData.set('version', '1');
        formData.set('metadata', this.formatMetadataForPost(metadata));
        if (customFile.tags.length > 0)
            formData.set('tags', customFile.tags.join(','));
        if (customFile.departments.length > 0)
            formData.set('departments', customFile.departments.join(','));
    }
    update(customFile) {
        this.configureHeaders();
        const formData = new FormData();
        formData.append('files', customFile.file, customFile.file.name);
        this.prepareFormData(formData, customFile);
        const progress = new Subject();
        this.http
            .patch(`${this.fileroomApi}/api/files`, formData, {
            headers: this.defaultHeaders,
            reportProgress: true,
            observe: 'events',
        })
            .subscribe((event) => {
            var _a, _b;
            if (event.type === HttpEventType.UploadProgress) {
                // Calculate and emit the upload progress
                const percentDone = Math.round((100 * event.loaded) / ((_a = event.total) !== null && _a !== void 0 ? _a : 1));
                progress.next(percentDone);
            }
            else if (event instanceof HttpResponse) {
                if (event.status >= 200 && event.status <= 300) {
                    let files = event === null || event === void 0 ? void 0 : event.body;
                    (_b = customFile.id) === null || _b === void 0 ? void 0 : _b.next(files[0].value); // Update the file object with the received ID
                }
                else {
                    //error state - display error text for this file.
                    console.log(event.statusText + '\n' + event.body);
                }
                progress.complete();
            }
        }, (error) => {
            // Handle upload error
            console.error('Upload error: ', error);
            progress.error(error);
        });
        return progress.asObservable();
    }
    formatMetadataForPost(inputArray) {
        const kvpObject = {};
        for (const pair of inputArray) {
            kvpObject[pair.key] = pair.value;
        }
        return JSON.stringify(kvpObject);
    }
}
FileroomUploadService.ɵprov = i0.ɵɵdefineInjectable({ factory: function FileroomUploadService_Factory() { return new FileroomUploadService(i0.ɵɵinject(i1.HttpClient)); }, token: FileroomUploadService, providedIn: "root" });
FileroomUploadService.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root',
            },] }
];
FileroomUploadService.ctorParameters = () => [
    { type: HttpClient }
];
FileroomUploadService.propDecorators = {
    fileroomApi: [{ type: Input }],
    fileroomApiKey: [{ type: Input }],
    siteId: [{ type: Input }],
    customerId: [{ type: Input }],
    authority: [{ type: Input }],
    household: [{ type: Input }],
    userId: [{ type: Input }],
    siteSection: [{ type: Input }],
    siteSectionId: [{ type: Input }],
    siteSubsection: [{ type: Input }]
};

class SnackbarErrorComponent {
}
SnackbarErrorComponent.decorators = [
    { type: Component, args: [{
                selector: 'kanso-fileroom-snack-bar-error',
                template: '<span class="error">Error:</span> There was an error processing your request.',
                styles: [`
      .error {
        /* background-color: #FF0000 !important; */
        text-transform: uppercase;
        color: #ff0000 !important;
        border-radius: 4px;
        max-width: 33vw;
        min-width: 344px;
        min-height: 48px;
        vertical-align: center;
        text-align: center;
      }
    `]
            },] }
];

class CustomFile {
    constructor(file) {
        this.id = new BehaviorSubject(null);
        this.tags = [];
        this.departments = [];
        this.file = file;
        this.id = new BehaviorSubject(null);
    }
}

class FileroomUploaderComponent {
    constructor(fb, dialogRef, uploadService, fileroomService, snackBar) {
        var _a;
        this.fb = fb;
        this.dialogRef = dialogRef;
        this.uploadService = uploadService;
        this.fileroomService = fileroomService;
        this.snackBar = snackBar;
        this.files = new Array();
        this.canBeClosed = true;
        this.primaryButtonText = 'Upload';
        this.showCancelButton = true;
        this.uploading = false;
        this.uploadSuccessful = false;
        this.showFileForm = false;
        this.enableExtendedEntry = false;
        this.tags = [];
        this.departments = [];
        this.tagdatasource = null;
        this.deptdatasource = null;
        this.displayedColumns = ['upload-extension', 'upload-name', 'upload-tags', 'upload-department', 'upload-actions'];
        // console.log('constructor');
        let config = dialogRef._containerInstance._config.data;
        if (config) {
            this.apiEndpoint = config.apiEndpoint;
            //setup read service endpoint info
            this.fileroomService.apiKey = config.apiKey;
            this.fileroomService.rootUrl = this.apiEndpoint;
            this.fileroomService.customerId = config.customerId;
            this.fileroomService.siteId = config.siteId;
            //setup write service endpoint info
            this.uploadService.fileroomApi = this.apiEndpoint;
            this.uploadService.fileroomApiKey = config.apiKey;
            this.uploadService.authority = config.customerId;
            this.uploadService.customerId = config.customerId;
            this.uploadService.siteId = config.siteId;
            this.uploadService.household = (_a = config === null || config === void 0 ? void 0 : config.householdId) !== null && _a !== void 0 ? _a : null;
            this.uploadService.userId = config.userId;
            this.uploadService.siteSection = config.siteSection;
            this.uploadService.siteSectionId = config.siteSectionId;
            this.uploadService.siteSubsection = config.siteSubsection;
            this.tagdatasource = new TagDataSource(this.fileroomService);
            this.deptdatasource = new DepartmentDataSource(this.fileroomService);
        }
        this.uploadForm = this.fb.group({});
        // console.log('leaving constructor');
    }
    ngOnInit() {
        // console.log('init');
        this.tagdatasource.connect().subscribe((res) => (this.tags = res));
        this.deptdatasource.connect().subscribe((res) => (this.departments = res));
        //  console.log('leaving init');
    }
    uploadFiles() {
        // Hide the cancel-button
        this.showCancelButton = false;
        // The dialog should not be closed while uploading
        this.canBeClosed = false;
        this.dialogRef.disableClose = true;
        this.files.forEach((customFile) => {
            // Subscribe to the ID BehaviorSubject of each file to handle the ID once set
            customFile.id.subscribe((id) => {
                if (id !== null) {
                    console.log(`File ${customFile.file.name} uploaded with ID: ${id}`);
                    // Update UI or application state as needed
                    this.canBeClosed = true;
                    this.dialogRef.disableClose = false;
                    this.uploadSuccessful = true;
                    this.uploading = false;
                    // The OK-button should have the text "Finish" now
                    this.primaryButtonText = 'Finish';
                }
            });
            this.uploadService.upload(customFile).subscribe((progress) => {
                // Optionally, update upload progress in the UI for each file
                console.log(`Upload progress for ${customFile.file.name}: ${progress}%`);
            }, (error) => {
                console.error(`Upload error for file ${customFile.file.name}:`, error);
                // Handle upload error, such as displaying a message to the user
                this.canBeClosed = false;
                this.dialogRef.disableClose = true;
            });
        });
    }
    updateFiles() {
        // Hide the cancel-button
        this.showCancelButton = false;
        // The dialog should not be closed while uploading
        this.canBeClosed = false;
        this.dialogRef.disableClose = true;
        this.files.forEach((customFile) => {
            // Subscribe to the ID BehaviorSubject of each file to handle the ID once set
            customFile.id.subscribe((id) => {
                if (id !== null) {
                    console.log(`File ${customFile.file.name} uploaded with ID: ${id}`);
                    // Update UI or application state as needed
                    this.canBeClosed = true;
                    this.dialogRef.disableClose = false;
                    this.uploadSuccessful = true;
                    this.uploading = false;
                    // The OK-button should have the text "Finish" now
                    this.primaryButtonText = 'Finish';
                }
            });
            this.uploadService.update(customFile).subscribe((progress) => {
                // Optionally, update upload progress in the UI for each file
                console.log(`Upload progress for ${customFile.file.name}: ${progress}%`);
            }, (error) => {
                console.error(`Upload error for file ${customFile.file.name}:`, error);
                // Handle upload error, such as displaying a message to the user
                this.canBeClosed = false;
                this.dialogRef.disableClose = true;
            });
        });
    }
    updateFileDepartments(file, event) {
        file.departments = event.value;
    }
    updateFileTags(file, event) {
        file.tags = event.value;
    }
    deleteById(id) {
        if (id == null)
            return;
        this.fileroomService.deleteFileById(id).subscribe((res) => {
            // noOp
        }, (err) => this.openSnackBarError());
    }
    openSnackBarError() {
        this.snackBar.openFromComponent(SnackbarErrorComponent, {
            duration: 100000,
        });
    }
    prepareFilesList(files) {
        for (const file of files) {
            const customFile = new CustomFile(file);
            this.files.push(customFile);
        }
        this.fileDropEl.nativeElement.value = '';
        this.uploadFiles(); // Proceed to upload
    }
    cancelUpload() {
        var _a, _b, _c;
        if (((_a = this.files) === null || _a === void 0 ? void 0 : _a.length) > 0) {
            for (const file of this.files) {
                if ((_b = file === null || file === void 0 ? void 0 : file.id) === null || _b === void 0 ? void 0 : _b.getValue()) {
                    this.deleteById((_c = file === null || file === void 0 ? void 0 : file.id) === null || _c === void 0 ? void 0 : _c.getValue());
                }
            }
            this.files = [];
        }
    }
    moveNext() {
        if (this.enableExtendedEntry) {
            this.showFileForm = true;
        }
        else {
            this.dialogRef.close(this.files);
        }
    }
    save() {
        this.updateFiles();
        this.dialogRef.close(this.files);
    }
    /**
     * on file drop handler
     */
    onFileDropped($event) {
        this.prepareFilesList($event);
    }
    /**
     * handle file from browsing
     */
    fileBrowseHandler(files) {
        this.prepareFilesList(files);
    }
    /**
     * Delete file from files list
     * @param index (File index)
     */
    deleteFile(index) {
        var _a, _b;
        const file = this.files[index];
        if ((_a = file === null || file === void 0 ? void 0 : file.id) === null || _a === void 0 ? void 0 : _a.getValue()) {
            this.deleteById((_b = file === null || file === void 0 ? void 0 : file.id) === null || _b === void 0 ? void 0 : _b.getValue());
        }
        this.files.splice(index, 1);
    }
    formatBytes(bytes, decimals = 2) {
        if (bytes === 0) {
            return '0 Bytes';
        }
        const k = 1024;
        const dm = decimals <= 0 ? 0 : decimals;
        const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
        const i = Math.floor(Math.log(bytes) / Math.log(k));
        return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
    }
    getFileExtension(theFile) {
        var _a;
        return (_a = theFile === null || theFile === void 0 ? void 0 : theFile.file.name.split('.').pop()) !== null && _a !== void 0 ? _a : '';
    }
}
FileroomUploaderComponent.decorators = [
    { type: Component, args: [{
                selector: 'kanso-fileroom-uploader',
                template: "<link href=\"https://fonts.googleapis.com/css?family=Roboto:300,400,500&display=swap\" rel=\"stylesheet\" />\n<link href=\"https://fonts.googleapis.com/icon?family=Material+Icons\" rel=\"stylesheet\" />\n<link href=\"https://stackpath.bootstrapcdn.com/font-awesome/4.7.0/css/font-awesome.min.css\" rel=\"stylesheet\" />\n\n<div id=\"uploadPanel1\" *ngIf=\"!this.showFileForm\">\n  <form [formGroup]=\"uploadForm\">\n    <input type=\"file\" #file style=\"display: none\" multiple />\n    <div class=\"container upload\" fxLayout=\"column\" fxLayoutAlign=\"space-evenly stretch\" appDnd (fileDropped)=\"onFileDropped($event)\">\n      <input type=\"file\" #fileDropRef id=\"fileDropRef\" multiple (change)=\"fileBrowseHandler($event.target.files)\" />\n      <h1 style=\"position: relative; top: -30px; left: -9px\">\n        <mat-icon class=\"fileroom-cloud-upload-icon\" alt=\"cloud upload\">cloud_upload</mat-icon>\n      </h1>\n      <h4 style=\"position: relative; top: -35px\">\n        Drag and drop<br />\n        or<br />\n        <button mat-raised-button class=\"fileroom-button fileroom-upload-button\" style=\"color: #fff !important\">Browse</button>\n      </h4>\n    </div>\n    <div class=\"container\" style=\"padding-top: 0; margin-top: 10px; text-align: justify\">\n      Hint: If you would like to tie a file or document to a specific entity (example, a household or work order) please upload from the\n      entity itself.\n    </div>\n\n    <div class=\"files-list\">\n      <div class=\"single-file\" *ngFor=\"let theFile of files; let i = index\">\n        <span class=\"fileroom-extension {{ getFileExtension(theFile) }}\">{{ getFileExtension(theFile) }}</span>\n        <div class=\"info\">\n          <h4 class=\"name\">{{ theFile.file?.name }}</h4>\n          <p class=\"size\">{{ formatBytes(theFile.file?.size) }}</p>\n        </div>\n\n        <span mat-icon-button [matMenuTriggerFor]=\"appMenu1\" class=\"fileroom-row-action\">\n          <mat-icon>more_vert</mat-icon>\n        </span>\n\n        <mat-menu #appMenu1=\"matMenu\">\n          <ng-template matMenuContent>\n            <button mat-menu-item class=\"fileroom-button-flat red\" (click)=\"deleteFile(i)\">Delete</button>\n          </ng-template>\n        </mat-menu>\n      </div>\n      <div *ngIf=\"files?.length >= 1\" class=\"container\" style=\"padding-top: 0; margin-top: 10px; text-align: center\">\n        <button\n          mat-raised-button\n          class=\"fileroom-button fileroom-upload-button btn btn-danger danger\"\n          style=\"margin-right: 10px\"\n          (click)=\"cancelUpload()\"\n        >\n          <span *ngIf=\"!this.enableExtendedEntry\">Cancel</span>\n        </button>\n        <button mat-raised-button class=\"fileroom-button fileroom-upload-button\" (click)=\"moveNext()\">\n          <span *ngIf=\"!this.enableExtendedEntry\">Confirm</span><span *ngIf=\"this.enableExtendedEntry\">Next</span>\n        </button>\n      </div>\n    </div>\n  </form>\n</div>\n\n<div id=\"uploadPanel2\" *ngIf=\"this.showFileForm && this.enableExtendedEntry\">\n  <h1>Edit New Uploads</h1>\n  <mat-table matSort [dataSource]=\"this.files\" width=\"100%\" style=\"width: 100%; min-width: 100%\">\n    <ng-container matColumnDef=\"upload-extension\">\n      <mat-header-cell *matHeaderCellDef> </mat-header-cell>\n      <mat-cell *matCellDef=\"let file\" style=\"width: 50px !important; max-width: 65px\">\n        <span class=\"fileroom-extension {{ getFileExtension(file) }} \">{{ getFileExtension(file) }} </span>\n      </mat-cell>\n    </ng-container>\n    <ng-container matColumnDef=\"upload-name\">\n      <mat-header-cell *matHeaderCellDef mat-sort-header>Name</mat-header-cell>\n\n      <mat-cell *matCellDef=\"let file\" style=\"width: 150px !important; max-width: 165px; margin-top: 10px; margin-left: 10px\">\n        <mat-form-field appearance=\"outline\">\n          <mat-label style=\"display: none\">Name</mat-label>\n          <input type=\"text\" matInput [value]=\"theFile.file.name\" />\n        </mat-form-field>\n      </mat-cell>\n    </ng-container>\n\n    <ng-container matColumnDef=\"upload-tags\">\n      <mat-header-cell *matHeaderCellDef>Tags</mat-header-cell>\n      <mat-cell *matCellDef=\"let file\" style=\"overflow: unset; margin-top: 10px; margin-left: 10px\">\n        <mat-form-field appearance=\"outline\">\n          <mat-label style=\"display: none\">Tags</mat-label>\n          <mat-select multiple (selectionChange)=\"updateFileTags(file, $event)\">\n            <mat-option>All</mat-option>\n            <mat-option *ngFor=\"let tag of this.tags\" [value]=\"theFile.file.tags\">\n              {{ tag.name }}\n            </mat-option>\n          </mat-select>\n        </mat-form-field>\n      </mat-cell>\n    </ng-container>\n\n    <ng-container matColumnDef=\"upload-department\">\n      <mat-header-cell *matHeaderCellDef>Department</mat-header-cell>\n      <mat-cell *matCellDef=\"let file\" style=\"overflow: unset; margin-top: 10px; margin-left: 10px\">\n        <mat-form-field appearance=\"outline\">\n          <mat-label style=\"display: none\">Department</mat-label>\n          <mat-select name=\"department\" multiple (selectionChange)=\"updateFileDepartments(file, $event)\">\n            <mat-option>All</mat-option>\n            <mat-option *ngFor=\"let dept of this.departments\" [value]=\"theFile.file.departments\">\n              {{ dept.name }}\n            </mat-option>\n          </mat-select>\n        </mat-form-field>\n      </mat-cell>\n    </ng-container>\n\n    <ng-container matColumnDef=\"upload-actions\" stickyEnd>\n      <mat-header-cell *matHeaderCellDef> </mat-header-cell>\n      <mat-cell *matCellDef=\"let theFile\" style=\"width: 35px !important; max-width: 50px; margin-top: 10px; margin-left: 10px\">\n        <span mat-icon-button [matMenuTriggerFor]=\"appMenu\" class=\"fileroom-row-action\">\n          <mat-icon>more_vert</mat-icon>\n        </span>\n\n        <mat-menu #appMenu=\"matMenu\">\n          <ng-template matMenuContent>\n            <button mat-menu-item class=\"fileroom-button-flat red\" (click)=\"deleteById(theFile.id)\">Delete</button>\n          </ng-template>\n        </mat-menu>\n      </mat-cell>\n    </ng-container>\n    <mat-header-row *matHeaderRowDef=\"displayedColumns\"></mat-header-row>\n    <mat-row *matRowDef=\"let row; columns: displayedColumns\"></mat-row>\n  </mat-table>\n  <div *ngIf=\"files.length >= 1\" class=\"container\" style=\"padding-top: 0; margin-top: 10px; text-align: center\">\n    <button mat-raised-button class=\"fileroom-button fileroom-upload-button\" (click)=\"save()\">Save</button>\n  </div>\n</div>\n",
                styles: [".add-files-btn{float:right}#mat-dialog-0{height:550px}:host{height:100%;display:flex;flex:1;flex-direction:column}.actions{justify-content:flex-end}.fileroom-cloud-upload-icon{text-align:center;font-size:72px!important;margin-top:15px;height:48px;width:48px;color:#00bcd4!important}.fileroom-button{color:#fff!important;background-color:#00bcd4!important;width:150px}.fileroom-button.cancel{background-color:#ccc!important;width:150px}.fileroom-button.danger{background-color:#c00!important}.fileroom-extension{background:grey;display:inline-block;border-radius:5px;color:#fff;font-weight:700;height:36px;text-align:center;text-transform:uppercase;margin-right:15px;min-height:48px;max-height:48px;height:48px;width:48px;min-width:48px;max-width:48px;padding:5px}.fileroom-extension.pdf{background:orange;color:#fff}.fileroom-extension.doc{background:#00bcd4;color:#fff}.fileroom-extension.csv{background:#9acd32;color:#fff}.container,.container.upload{width:450px;padding:2rem;text-align:center;position:relative;margin:0 auto}.container.upload{height:200px;background-color:#efefef}.container.upload input{opacity:0;position:absolute;z-index:2;width:100%;height:100%;top:0;left:0}.container.upload h3{font-size:20px;font-weight:600;color:#38424c}.fileover{animation:shake 1s;animation-iteration-count:infinite}.files-list .single-file{padding:.25rem;justify-content:space-between;align-items:center;display:flex;flex-grow:1}.files-list .single-file img.delete{margin-left:.5rem;cursor:pointer;align-self:flex-end}.files-list .single-file .name{font-size:14px;font-weight:500;color:#353f4a;margin:0}.files-list .single-file .size{font-size:12px;font-weight:500;color:#a4a4a4;margin:0 0 .25rem}.files-list .single-file .info{width:100%}@keyframes shake{0%{transform:translate(1px,1px) rotate(0deg)}10%{transform:translate(-1px,-2px) rotate(-1deg)}20%{transform:translate(-3px) rotate(1deg)}30%{transform:translate(3px,2px) rotate(0deg)}40%{transform:translate(1px,-1px) rotate(1deg)}50%{transform:translate(-1px,2px) rotate(-1deg)}60%{transform:translate(-3px,1px) rotate(0deg)}70%{transform:translate(3px,1px) rotate(-1deg)}80%{transform:translate(-1px,-1px) rotate(1deg)}90%{transform:translate(1px,2px) rotate(0deg)}to{transform:translate(1px,-2px) rotate(-1deg)}}"]
            },] }
];
FileroomUploaderComponent.ctorParameters = () => [
    { type: FormBuilder },
    { type: MatDialogRef },
    { type: FileroomUploadService },
    { type: FileroomService },
    { type: MatSnackBar }
];
FileroomUploaderComponent.propDecorators = {
    fileDropEl: [{ type: ViewChild, args: ['fileDropRef', { static: false },] }]
};

class DndDirective {
    constructor() {
        this.fileDropped = new EventEmitter();
    }
    // Dragover listener
    onDragOver(evt) {
        evt.preventDefault();
        evt.stopPropagation();
        this.fileOver = true;
    }
    // Dragleave listener
    onDragLeave(evt) {
        evt.preventDefault();
        evt.stopPropagation();
        this.fileOver = false;
    }
    // Drop listener
    ondrop(evt) {
        evt.preventDefault();
        evt.stopPropagation();
        this.fileOver = false;
        const files = evt.dataTransfer.files;
        if (files.length > 0) {
            this.fileDropped.emit(files);
        }
    }
}
DndDirective.decorators = [
    { type: Directive, args: [{
                selector: '[appDnd]',
            },] }
];
DndDirective.propDecorators = {
    fileOver: [{ type: HostBinding, args: ['class.fileover',] }],
    fileDropped: [{ type: Output }],
    onDragOver: [{ type: HostListener, args: ['dragover', ['$event'],] }],
    onDragLeave: [{ type: HostListener, args: ['dragleave', ['$event'],] }],
    ondrop: [{ type: HostListener, args: ['drop', ['$event'],] }]
};

class MaterialModule {
}
MaterialModule.decorators = [
    { type: NgModule, args: [{
                exports: [
                    A11yModule,
                    ClipboardModule,
                    CdkStepperModule,
                    CdkTableModule,
                    CdkTreeModule,
                    DragDropModule,
                    MatAutocompleteModule,
                    MatBadgeModule,
                    MatBottomSheetModule,
                    MatButtonModule,
                    MatButtonToggleModule,
                    MatCardModule,
                    MatCheckboxModule,
                    MatChipsModule,
                    MatStepperModule,
                    MatDatepickerModule,
                    MatDialogModule,
                    MatDividerModule,
                    MatExpansionModule,
                    MatGridListModule,
                    MatIconModule,
                    MatInputModule,
                    MatListModule,
                    MatMenuModule,
                    MatNativeDateModule,
                    MatPaginatorModule,
                    MatProgressBarModule,
                    MatProgressSpinnerModule,
                    MatRadioModule,
                    MatRippleModule,
                    MatSelectModule,
                    MatSidenavModule,
                    MatSliderModule,
                    MatSlideToggleModule,
                    MatSnackBarModule,
                    MatSortModule,
                    MatTableModule,
                    MatTabsModule,
                    MatToolbarModule,
                    MatTooltipModule,
                    MatTreeModule,
                    OverlayModule,
                    PortalModule,
                    ScrollingModule,
                ],
            },] }
];

const ɵ0$1 = { appearance: 'fill' };
class FileroomUploaderModule {
}
FileroomUploaderModule.decorators = [
    { type: NgModule, args: [{
                declarations: [FileroomUploaderComponent, DndDirective, SnackbarErrorComponent],
                imports: [
                    BrowserModule,
                    BrowserAnimationsModule,
                    CommonModule,
                    FormsModule,
                    ReactiveFormsModule,
                    MatDatepickerModule,
                    MatInputModule,
                    MatFormFieldModule,
                    MatNativeDateModule,
                    MaterialModule,
                    HttpClientModule,
                ],
                providers: [FileroomUploadService, { provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: ɵ0$1 }],
                exports: [FileroomUploaderComponent],
                entryComponents: [FileroomUploaderComponent, SnackbarErrorComponent],
            },] }
];

class FileroomDeleteConfirmComponent {
    constructor(dialogRef) {
        this.dialogRef = dialogRef;
    }
    cancel() {
        this.dialogRef.close({ event: 'close', data: false });
    }
    confirm() {
        this.dialogRef.close({ event: 'close', data: true });
    }
}
FileroomDeleteConfirmComponent.decorators = [
    { type: Component, args: [{
                selector: 'kanso-fileroom-delete-confirm',
                template: `<div id="deleteConfirmModal">
    <span style="width:100%;justify-content: center;"> <h1 mat-dialog-title>Are you sure?</h1></span>
    <div mat-dialog-content>Are you sure you want to delete this document?<br />This action cannot be undone.</div>
    <div>
      <br /><br />
      <div mat-dialog-actions>
        <button mat-raised-button class="delete-confirm-modal-button fileroom-button cancel" (click)="cancel()">Cancel</button>
        <button mat-raised-button class="delete-confirm-modal-button fileroom-button danger" (click)="confirm()">Delete</button>
      </div>
    </div>
  </div>`,
                styles: [`
      .delete-confirm-modal-button {
        box-sizing: border-box;
        position: relative;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
        cursor: pointer;
        outline: none;
        border: none;
        -webkit-tap-highlight-color: transparent;
        display: inline-block;
        white-space: nowrap;
        text-decoration: none;
        vertical-align: baseline;
        text-align: center;
        margin: 0;
        min-width: 64px;
        line-height: 36px;
        padding: 0 16px;
        border-radius: 4px;
        overflow: visible;
        transform: translate3d(0, 0, 0);
        transition: background 400ms cubic-bezier(0.25, 0.8, 0.25, 1), box-shadow 280ms cubic-bezier(0.4, 0, 0.2, 1);
        color: rgba(0, 0, 0, 0.87);
        background-color: white;
        font-family: Roboto, 'Helvetica Neue', sans-serif;
        font-size: 14px;
        font-weight: 500;
        background-color: #4a6572 !important;
        color: white !important;
      }

      .delete-confirm-modal-button.fileroom-button.cancel {
        background-color: #ccc !important;
        width: 150px;
      }

      .delete-confirm-modal-button.fileroom-button.danger {
        background-color: #cc0000 !important;
        width: 150px;
        margin-left: 20px !important;
      }

      .error {
        /* background-color: #FF0000 !important; */
        text-transform: uppercase;
        color: #ff0000 !important;
        border-radius: 4px;
        max-width: 33vw;
        min-width: 344px;
        min-height: 48px;
        vertical-align: center;
        text-align: center;
      }
    `]
            },] }
];
FileroomDeleteConfirmComponent.ctorParameters = () => [
    { type: MatDialogRef }
];

class FileroomDashboardComponent {
    constructor(fb, fileroomService, dialog, fileroomUploadService, snackBar) {
        this.fb = fb;
        this.fileroomService = fileroomService;
        this.dialog = dialog;
        this.fileroomUploadService = fileroomUploadService;
        this.snackBar = snackBar;
        this.authority = '';
        this.household = '';
        this.rootApiUrl = '';
        this.rootApiKey = '';
        this.actions = [];
        this.criteria = new SearchCriteria();
        this.tagdatasource = new TagDataSource(this.fileroomService);
        this.deptdatasource = new DepartmentDataSource(this.fileroomService);
        this.displayedColumns = ['extension', 'name', 'tags', 'department', 'customActions', 'lastModified', 'actions'];
        this.tags = [];
        this.departments = [];
        this.files = [];
        this.chips = [];
        this.flyoutActions = [];
        this.filesDatasource = new MatTableDataSource(this.files);
        this.pageSize = 10;
    }
    ngAfterViewInit() { }
    ngOnInit() {
        this.filesDatasource.paginator = this.paginator;
        this.filesDatasource.sort = this.sort;
        this.searchForm = this.fb.group({
            extension: new FormControl(),
            keyword: new FormControl(),
            tags: new FormControl(),
            department: new FormControl(),
            startDate: new FormControl(),
            endDate: new FormControl(),
        });
        if (!this.actions || this.actions.length === 0) {
            this.addMockActions();
        }
        this.configureActions();
        this.refresh();
    }
    addMockActions() {
        const echoFileId = {
            print(msg) {
                console.log(msg);
            },
            execute(file, fileData) {
                this.print('Delegate for Echo running for file id: ' + file.id);
                this.print('Delegate for Echo got a file with a size of ' + fileData.size);
            },
        };
        const echoAction = new Action();
        echoAction.type = ActionType.Flyout;
        echoAction.icon = 'surround_sound';
        echoAction.delegate = echoFileId;
        echoAction.name = 'Echo';
        echoAction.position = 0;
        this.actions.push(echoAction);
        const visibleFileId = {
            print(msg) {
                console.log(msg);
            },
            execute(file, fileData) {
                this.print('Delegate for IsVisible running for file id: ' + file.id);
                this.print('Delegate for IsVisible got a file with a size of ' + fileData.size);
            },
        };
        const visibleAction = new Action();
        visibleAction.type = ActionType.Toggle;
        visibleAction.icon = 'visibility';
        visibleAction.delegate = visibleFileId;
        visibleAction.name = 'Tenant Visble';
        visibleAction.position = 0;
        this.actions.push(visibleAction);
        // load example data for each.
        const myTempObject = {
            print(msg) {
                console.log(msg);
            },
            execute(fileId) {
                this.print(fileId);
            },
        };
        for (let i = 0; i < 5; i++) {
            const action = new Action();
            if (i % 2 === 0) {
                action.type = ActionType.Flyout;
                action.icon = 'all_out';
            }
            else {
                action.type = ActionType.Button;
                action.icon = 'bug_report';
            }
            action.delegate = myTempObject;
            action.name = 'Action ' + i;
            action.position = i;
            this.actions.push(action);
        }
    }
    openUploadDialog() {
        // const dialogRef = this.dialog
        //   .open(FileroomUploaderComponent)
        //   .afterClosed()
        //   .subscribe((result) => {
        //     console.log('The upload dialog was closed', result);
        //     if (result) {
        //       this.refresh();
        //     }
        //   });
        var _a, _b;
        const siteId = sessionStorage.getItem('SITEID');
        const customerId = sessionStorage.getItem('CUSTOMERID');
        let api = (_a = sessionStorage.getItem('FILEROOM_SERVICE_URI')) !== null && _a !== void 0 ? _a : this.rootApiUrl;
        if (api == '') {
            api = this.fileroomService.rootUrl;
        }
        let apikey = (_b = sessionStorage.getItem('FILEROOM_SERVICE_API_KEY')) !== null && _b !== void 0 ? _b : this.rootApiKey;
        if (apikey == '') {
            apikey = this.fileroomService.apiKey;
        }
        const householdId = sessionStorage.getItem('HOUSEHOLDID');
        const dialogRef = this.dialog
            .open(FileroomUploaderComponent, {
            data: {
                apiEndpoint: api,
                apiKey: apikey,
                userId: "kanso",
                customerId: customerId,
                siteId: siteId,
                householdId: null,
                siteSection: null,
                siteSectionId: null,
                siteSubsection: null,
            },
        })
            .afterClosed()
            .subscribe(result => {
            console.log('The upload dialog was closed', result);
            if (result) {
                this.refresh();
            }
        });
    }
    openDeleteConfirmDialog(id) {
        const dialogRef = this.dialog
            .open(FileroomDeleteConfirmComponent, { width: '25%', height: '25%', data: { fileId: id } })
            .afterClosed()
            .subscribe((result) => {
            console.log('The dialog was closed', result);
            if (result.data) {
                this.fileroomService.deleteFileById(id).subscribe((res) => {
                    this.refresh();
                }, (err) => this.openSnackBarError());
            }
        });
    }
    refreshSearchChips() {
        this.chips = [];
        if (this.criteria) {
            if (this.criteria.tags) {
                this.chips.push(this.criteria.tags.map((item) => ({ type: 'tag', value: item })));
            }
            if (this.criteria.departments) {
                this.chips.push(this.criteria.departments.map((item) => ({ type: 'department', value: item })));
            }
            if (this.criteria.keywords) {
                this.chips.push(this.criteria.keywords.map((item) => ({ type: 'keyword', value: item })));
            }
            if (this.criteria.startDate && this.criteria.endDate) {
                this.chips.push({
                    type: 'date',
                    value: this.criteria.startDate.toLocaleDateString('en-US') + ' - ' + this.criteria.endDate.toLocaleDateString('en-US'),
                });
            }
        }
        this.chips = [].concat(this.chips[0], this.chips[1], this.chips[2], this.chips[3]).filter((ele) => {
            return ele != null;
        });
    }
    openSnackBarError() {
        this.snackBar.openFromComponent(SnackbarErrorComponent, {
            duration: 100000,
        });
    }
    deleteById(id) {
        this.openDeleteConfirmDialog(id);
    }
    edit(id) {
        const file = this.files.find((x) => x.id === id);
        if (file) {
            file.isEditing = true;
        }
    }
    save(id) {
        // do the save
        const file = this.files.find((x) => x.id === id);
        // TODO: Call Save api
        if (file) {
            file.isEditing = false;
        }
    }
    viewFile(id, filename) {
        this.fileroomService.getFileById(id).subscribe((data) => {
            const file = new Blob([data], { type: 'application/pdf' });
            const fileURL = URL.createObjectURL(file);
            window.open(fileURL);
        }, (err) => this.openSnackBarError());
    }
    downloadFile(id, filename) {
        this.fileroomService.getFileById(id).subscribe((data) => {
            const downloadUrl = window.URL.createObjectURL(data);
            const link = document.createElement('a');
            link.href = downloadUrl;
            link.download = filename;
            link.click();
        }, (err) => this.openSnackBarError());
    }
    refresh() {
        this.tagdatasource.connect().subscribe((res) => (this.tags = res));
        this.deptdatasource.connect().subscribe((res) => (this.departments = res));
        this.fileroomService.getFiles().subscribe((res) => {
            this.files = res;
            this.filesDatasource.data = this.files;
            this.filesDatasource.paginator = this.paginator;
            this.filesDatasource.sort = this.sort;
            this.filesDatasource.paginator.pageSize = this.pageSize;
        });
    }
    removeSearchCriterion(criterion, type) {
        console.log(criterion);
        switch (type) {
            case 'tag':
                this.criteria.tags = this.arrayRemove(this.criteria.tags, criterion);
                this.searchForm.controls['tags'].setValue(this.criteria.tags);
                break;
            case 'department':
                this.criteria.departments = this.arrayRemove(this.criteria.departments, criterion);
                this.searchForm.controls['department'].setValue(this.criteria.departments);
                break;
            case 'keyword':
                this.criteria.keywords = this.arrayRemove(this.criteria.keywords, criterion);
                if (this.searchForm.controls['keyword'].value !== '') {
                    this.searchForm.controls['keyword'].setValue(this.criteria.keywords.join(' '));
                }
                else {
                    this.searchForm.controls['keyword'].setValue(null);
                }
                break;
            case 'date':
                this.searchForm.controls['startDate'].setValue(null);
                this.searchForm.controls['endDate'].setValue(null);
                break;
        }
        this.onSearch();
    }
    arrayRemove(arr, value) {
        return arr.filter((ele) => {
            return ele !== value;
        });
    }
    onSearch() {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        this.criteria.authority = this.authority;
        this.criteria.household = this.household;
        this.criteria.keywords = (_a = this.searchForm.get('keyword')) === null || _a === void 0 ? void 0 : _a.value.split(' ');
        this.criteria.tags = (_b = this.searchForm.get('tags')) === null || _b === void 0 ? void 0 : _b.value;
        this.criteria.departments = (_c = this.searchForm.get('department')) === null || _c === void 0 ? void 0 : _c.value;
        if (((_d = this.searchForm.get('startDate')) === null || _d === void 0 ? void 0 : _d.value) !== null && ((_e = this.searchForm.get('startDate')) === null || _e === void 0 ? void 0 : _e.value) !== undefined) {
            this.criteria.startDate = new Date((_f = this.searchForm.get('startDate')) === null || _f === void 0 ? void 0 : _f.value);
        }
        else {
            this.criteria.startDate = null;
        }
        if (((_g = this.searchForm.get('endDate')) === null || _g === void 0 ? void 0 : _g.value) !== null && ((_h = this.searchForm.get('endDate')) === null || _h === void 0 ? void 0 : _h.value) !== undefined) {
            this.criteria.endDate = new Date((_j = this.searchForm.get('endDate')) === null || _j === void 0 ? void 0 : _j.value);
        }
        else {
            this.criteria.endDate = null;
        }
        this.fileroomService.search(this.criteria).subscribe((res) => {
            this.files = res;
            this.filesDatasource.data = this.files;
            this.filesDatasource.paginator = this.paginator;
            this.filesDatasource.sort = this.sort;
            this.refreshSearchChips();
        });
    }
    runAction(action, file) {
        let fileData = null;
        this.fileroomService.getFileById(file.id).subscribe((data) => {
            fileData = data;
            if (action && action.delegate) {
                action.delegate.execute(file, fileData);
            }
        }, (err) => this.openSnackBarError());
    }
    configureActions() {
        if (this.actions && this.actions.length > 0) {
            this.flyoutActions = this.actions.filter((x) => x.type === ActionType.Flyout);
        }
    }
    getActionsWithoutFlyouts() {
        if (this.actions && this.actions.length > 0) {
            const filtered = this.actions.filter((x) => x.type !== ActionType.Flyout);
            return filtered;
        }
        return [];
    }
}
FileroomDashboardComponent.decorators = [
    { type: Component, args: [{
                selector: 'kanso-fileroom-dashboard',
                template: "<link href=\"https://fonts.googleapis.com/css?family=Roboto:300,400,500&display=swap\" rel=\"stylesheet\">\n<link href=\"https://fonts.googleapis.com/icon?family=Material+Icons\" rel=\"stylesheet\">\n<link href=\"https://stackpath.bootstrapcdn.com/font-awesome/4.7.0/css/font-awesome.min.css\" rel=\"stylesheet\">\n\n\n<mat-card>\n  <mat-card-header>\n    <mat-card-title id=\"header\">\n      <h1>\n        Document Directory\n        <span flex></span>\n        <button mat-raised-button class=\"fileroom-button fileroom-upload-button\" (click)=\"openUploadDialog()\">\n          Upload New <mat-icon class=\"fileroom-upload-button-add-align\">add</mat-icon>\n        </button>\n      </h1>\n    </mat-card-title>\n  </mat-card-header>\n  <mat-card-content>\n    <form [formGroup]=\"searchForm\">\n      <mat-form-field appearance=\"outline\">\n        <mat-label>Keywords</mat-label>\n        <mat-icon matPrefix>search</mat-icon>\n        <input matInput name=\"keyword\" formControlName=\"keyword\" />\n      </mat-form-field>\n\n      <mat-form-field appearance=\"outline\">\n        <mat-label>Tags</mat-label>\n        <mat-select name=\"tags\" formControlName=\"tags\" multiple>\n          <mat-option>All</mat-option>\n          <mat-option *ngFor=\"let tag of this.tags\" [value]=\"tag.name\">\n            {{ tag.name }}\n          </mat-option>\n        </mat-select>\n      </mat-form-field>\n\n      <mat-form-field appearance=\"outline\">\n        <mat-label>Department</mat-label>\n        <mat-select name=\"department\" formControlName=\"department\" multiple>\n          <mat-option>All</mat-option>\n          <mat-option *ngFor=\"let dept of this.departments\" [value]=\"dept.name\">\n            {{ dept.name }}\n          </mat-option>\n        </mat-select>\n      </mat-form-field>\n\n      <mat-form-field appearance=\"outline\">\n        <mat-label>Enter a date range</mat-label>\n        <mat-date-range-input [rangePicker]=\"picker\">\n          <input matStartDate placeholder=\"Start date\" name=\"startDate\" formControlName=\"startDate\" />\n          <input matEndDate placeholder=\"End date\" name=\"endDate\" formControlName=\"endDate\" />\n        </mat-date-range-input>\n        <mat-datepicker-toggle matSuffix [for]=\"picker\"></mat-datepicker-toggle>\n        <mat-date-range-picker #picker color=\"accent\"></mat-date-range-picker>\n      </mat-form-field>\n      <button class=\"fileroom-button fileroom-search-button\" mat-raised-button (click)=\"onSearch()\">Search</button>\n    </form>\n\n    <mat-chip-list #chipList aria-label=\"search selection\">\n      <mat-chip *ngFor=\"let chip of this.chips\" (removed)=\"this.removeSearchCriterion(chip.value, chip.type)\">\n        {{ chip.value }}\n        <mat-icon matChipRemove>cancel</mat-icon>\n      </mat-chip>\n    </mat-chip-list>\n  </mat-card-content>\n</mat-card>\n\n<div><p></p></div>\n<div><p></p></div>\n\n<mat-card>\n  <mat-card-content>\n    <div>\n      <mat-table [dataSource]=\"filesDatasource\" matSort>\n        <ng-container matColumnDef=\"extension\">\n          <mat-header-cell *matHeaderCellDef> </mat-header-cell>\n          <mat-cell *matCellDef=\"let file\">\n            <span class=\"fileroom-extension {{ file.extension }} \">{{ file.extension }} </span></mat-cell\n          >\n        </ng-container>\n        <ng-container matColumnDef=\"name\">\n          <mat-header-cell *matHeaderCellDef mat-sort-header> Name </mat-header-cell>\n          <mat-cell *matCellDef=\"let file\">\n            <a (click)=\"this.viewFile(file.id, file.name)\">\n              {{ file.name }}\n            </a>\n          </mat-cell>\n        </ng-container>\n        <ng-container matColumnDef=\"tags\">\n          <mat-header-cell *matHeaderCellDef>Tags</mat-header-cell>\n          <mat-cell *matCellDef=\"let file\">\n            <mat-form-field appearance=\"outline\" *ngIf=\"file.isEditing\">\n              <mat-label>Tags</mat-label>\n              <mat-select multiple>\n                <mat-option>All</mat-option>\n                <mat-option *ngFor=\"let tag of this.tags\" [(value)]=\"file.tags[tag]\">\n                  {{ tag.name }}\n                </mat-option>\n              </mat-select>\n            </mat-form-field>\n\n            <span *ngIf=\"!file.isEditing\"> {{ file.tags.length > 20 ? file.tags.slice(0, 20) + '...' : file.tags }}</span>\n          </mat-cell>\n        </ng-container>\n        <ng-container matColumnDef=\"department\">\n          <mat-header-cell *matHeaderCellDef> Department </mat-header-cell>\n          <mat-cell *matCellDef=\"let file\">\n            <mat-form-field appearance=\"outline\" *ngIf=\"file.isEditing\">\n              <mat-label>Department</mat-label>\n              <mat-select name=\"department\" multiple value=\"{{ file.department }}\">\n                <mat-option>All</mat-option>\n                <mat-option *ngFor=\"let dept of this.departments\" [value]=\"dept.name\">\n                  {{ dept.name }}\n                </mat-option>\n              </mat-select>\n            </mat-form-field>\n            <span *ngIf=\"!file.isEditing\"> {{ file.department }}</span>\n          </mat-cell>\n        </ng-container>\n\n        <ng-container *ngIf=\"this.actions.length > 0\" matColumnDef=\"customActions\">\n          <mat-header-cell *matHeaderCellDef></mat-header-cell>\n          <mat-cell *matCellDef=\"let file\">\n            <span *ngFor=\"let action of this.getActionsWithoutFlyouts()\">\n              <button *ngIf=\"action.type === 'button'\" mat-menu-item class=\"fileroom-button-flat blue\" (click)=\"runAction(action, file)\">\n                <mat-icon *ngIf=\"action.icon\">{{ action.icon }}</mat-icon\n                ><span *ngIf=\"action.displayText\">{{ action.name }}</span>\n              </button>\n              <mat-slide-toggle *ngIf=\"action.type === 'toggle'\" (click)=\"runAction(action, file)\">\n                {{ action.name }}\n              </mat-slide-toggle>\n            </span>\n          </mat-cell>\n        </ng-container>\n\n        <ng-container matColumnDef=\"lastModified\">\n          <mat-header-cell *matHeaderCellDef> Last Modified</mat-header-cell>\n          <mat-cell *matCellDef=\"let file\">\n            {{ file.createdOn | date : 'medium' }} by {{ file.createdBy == null ? 'unknown' : file.createdBy }}\n          </mat-cell>\n        </ng-container>\n        <ng-container matColumnDef=\"actions\" stickyEnd>\n          <mat-header-cell *matHeaderCellDef> </mat-header-cell>\n          <mat-cell *matCellDef=\"let file\">\n            <div *ngIf=\"file.isEditing\">\n              <span mat-icon-button style=\"display: inline-block; cursor: pointer\" class=\"fileroom-row-action\">\n                <mat-icon (click)=\"this.save(file.id)\" style=\"color: #00bcd4\">check_circle</mat-icon>\n              </span>\n            </div>\n            <div *ngIf=\"!file.isEditing\">\n              <span mat-icon-button style=\"display: inline-block; cursor: pointer\" class=\"fileroom-row-action\">\n                <mat-icon (click)=\"this.downloadFile(file.id, file.contentType, file.name)\">cloud_download</mat-icon>\n              </span>\n\n              <span mat-icon-button [matMenuTriggerFor]=\"appMenu\" class=\"fileroom-row-action\">\n                <mat-icon>more_vert</mat-icon>\n              </span>\n\n              <mat-menu #appMenu=\"matMenu\">\n                <ng-template matMenuContent>\n                  <button mat-menu-item class=\"fileroom-button-flat blue\" (click)=\"edit(file.id)\">Edit</button>\n                  <hr class=\"fileroom-menu-seperator\" />\n                  <button mat-menu-item class=\"fileroom-button-flat red\" (click)=\"deleteById(file.id)\">Delete</button>\n\n                  <hr *ngIf=\"this.flyoutActions.length > 0\" class=\"fileroom-menu-seperator\" />\n                  <button\n                    *ngFor=\"let action of this.flyoutActions\"\n                    mat-menu-item\n                    class=\"fileroom-button-flat blue\"\n                    (click)=\"runAction(action, file)\"\n                  >\n                    <mat-icon *ngIf=\"action.icon\">{{ action.icon }}</mat-icon> {{ action.name }}\n                  </button>\n                </ng-template>\n              </mat-menu>\n            </div>\n          </mat-cell>\n        </ng-container>\n        <mat-header-row *matHeaderRowDef=\"displayedColumns\"></mat-header-row>\n        <mat-row *matRowDef=\"let row; columns: displayedColumns\"></mat-row>\n        <!-- Row shown when there is no matching data. -->\n        <tr class=\"mat-row\" *matNoDataRow>\n          <td class=\"mat-cell\" colspan=\"4\">No data matching the filters selected.</td>\n        </tr>\n      </mat-table>\n    </div>\n  </mat-card-content>\n  <mat-card-footer>\n    <mat-paginator\n      appearance=\"default\"\n      [length]=\"files.length\"\n      [pageSize]=\"this.pageSize\"\n      [pageSizeOptions]=\"[3, 5, 10, 20]\"\n      showFirstLastButtons\n    ></mat-paginator>\n  </mat-card-footer>\n</mat-card>\n",
                styles: [".mat-table{width:100%}.fileroom-cloud-upload-icon{font-size:48px!important;margin-top:15px;height:48px;width:48px}.fileroom-button{background-color:#00bcd4!important}::ng-deep.fileroom-button.cancel{background-color:#ccc!important;width:150px}::ng-deep.fileroom-button.danger{background-color:#c00!important;width:150px}.fileroom-button-flat{text-align:center;background-color:transparent!important}.fileroom-button-flat,.fileroom-menu-seperator{padding-top:0;padding-bottom:0;margin-top:0;margin-bottom:0}.fileroom-menu-seperator{color:grey;width:75%}.fileroom-button-flat.blue{color:#00bcd4!important}.fileroom-button-flat.red{color:#c00!important}.fileroom-upload-button{position:absolute;right:35px;width:150px}.fileroom-upload-button-add-align{padding:0;margin-left:.3em;vertical-align:middle}.fileroom-search-button{position:absolute;right:35px;padding:.3em;margin-top:.4em;width:120px;text-align:center;vertical-align:middle}.fileroom-extension{height:30px;width:50px;background:grey;color:#fff;border-radius:.5em;vertical-align:middle;text-align:center;padding-top:15px;padding-bottom:5px;text-transform:uppercase}.fileroom-extension.pdf{background:orange;color:#fff}.fileroom-extension.doc{background:#00bcd4;color:#fff}.fileroom-extension.csv{background:#9acd32;color:#fff}.fileroom-row-action{color:grey}.mat-row{margin-top:10px;padding-bottom:10px}.cdk-overlay-pane{border-radius:.5em}.cdk-column-extension,.mat-column-extension{flex:5%!important;width:5%!important;padding-right:8px}.cdk-column-name,.mat-column-name{flex:25%!important;width:25%!important;cursor:pointer}.cdk-column-name,.cdk-column-tags,.mat-column-name,.mat-column-tags{overflow:hidden;padding-right:8px;text-overflow:ellipsis;white-space:nowrap}.cdk-column-tags,.mat-column-tags{flex:24%!important;width:24%!important}.cdk-column-department,.mat-column-department{text-overflow:ellipsis}.cdk-column-customActions,.cdk-column-department,.cdk-column-lastModified,.mat-column-customActions,.mat-column-department,.mat-column-lastModified{overflow:hidden;flex:25%!important;width:25%!important;padding-right:8px;white-space:nowrap}.cdk-column-lastModified,.mat-column-lastModified{text-overflow:ellipsis}.cdk-column-actions,.mat-column-actions{flex:5%!important;width:5%!important;padding-left:8px;padding-right:2px;cursor:pointer}.mat-column-position{padding-left:8px}::ng-deep.mat-select-arrow,::ng-deep.mat-select-arrow-wrapper{color:#00bcd4!important;background-color:transparent!important}::ng-deep.mat-pseudo-checkbox-checked,::ng-deep.mat-pseudo-checkbox-indeterminate{background:#00bcd4!important}::ng-deep.mat-icon-button{color:#00bcd4!important;background-color:transparent!important}::ng-deep.mat-calendar-period-button,::ng-deep.mat-pseudo-checkbox-checked{background-color:#00bcd4!important;color:#fff!important}::ng-deep.mat-menu-panel{border-radius:50px}::ng-deep.mat-cell{color:rgba(0,0,0,.54)!important}::ng-deep.mat-chip,::ng-deep.mat-chip-trailing-icon,::ng-deep.mat-chip-with-trailing-icon ::ng-deep.mat-chip-remove,::ng-deep.mat-standard-chip{background-color:#00bcd4!important;color:#fff!important;border-radius:10px!important}"]
            },] }
];
FileroomDashboardComponent.ctorParameters = () => [
    { type: FormBuilder },
    { type: FileroomService },
    { type: MatDialog },
    { type: FileroomUploadService },
    { type: MatSnackBar }
];
FileroomDashboardComponent.propDecorators = {
    authority: [{ type: Input }],
    household: [{ type: Input }],
    rootApiUrl: [{ type: Input }],
    rootApiKey: [{ type: Input }],
    actions: [{ type: Input }],
    paginator: [{ type: ViewChild, args: [MatPaginator, { static: false },] }],
    sort: [{ type: ViewChild, args: [MatSort, { static: false },] }]
};

const ɵ0 = { appearance: 'fill' };
class FileroomDashboardModule {
}
FileroomDashboardModule.decorators = [
    { type: NgModule, args: [{
                declarations: [FileroomDashboardComponent],
                imports: [
                    BrowserModule,
                    BrowserAnimationsModule,
                    CommonModule,
                    FormsModule,
                    ReactiveFormsModule,
                    MatDatepickerModule,
                    MatInputModule,
                    MatFormFieldModule,
                    MatNativeDateModule,
                    MaterialModule,
                    HttpClientModule,
                    MatDialogModule,
                ],
                providers: [FileroomService, FileroomDataSource, { provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: ɵ0 }],
                exports: [FileroomDashboardComponent],
                entryComponents: [FileroomDashboardComponent],
            },] }
];

/*
 * Public API Surface of kanso-fileroom-lib
 */

/**
 * Generated bundle index. Do not edit.
 */

export { Action, ActionType, Department, DepartmentDataSource, DndDirective, FileroomDashboardComponent, FileroomDashboardModule, FileroomDataSource, FileroomFile, FileroomService, FileroomUploadService, FileroomUploaderComponent, FileroomUploaderModule, MaterialModule, SearchCriteria, SnackbarErrorComponent, Tag, TagDataSource };
//# sourceMappingURL=hds1-fileroom.js.map
